import React, { useLayoutEffect, useRef, useState } from 'react'
import { File, X } from 'react-feather'

import { formatBytes } from '../../../constants/validate'

import './index.scss'

/**
 * @param {String} fileName - DateTime value
 * @param {Boolean} showIcon - Defines visibility of document icon
 * @param {Number} fileSize - Size of file
 * @param {Boolean} removeButton - Defines visibility of button to remove file
 * @param {String} externalLink - Defines if component has a externalLink
 * @param {Boolean} showLoading - Defines visibility of spinner
 * @param {Function} removeAction - Call function to remove file
 *
 * @returns {React.ReactElement}
 */

function Attachment({
  fileName = 'file_sample.txt',
  showIcon = true,
  fileSize,
  removeButton = true,
  externalLink = '',
  showLoading = false,
  removeAction = () => {},
}) {
  const nameRef = useRef(null)
  const [nameWidth, setNameWidth] = useState('')

  function handleClickRemoveFile() {
    removeAction && removeAction()
  }

  function handleClickFile() {
    externalLink && window.open(externalLink, '_blank')
  }

  useLayoutEffect(() => {
    if (nameRef.current) {
      setNameWidth(nameRef.current.parentElement.getBoundingClientRect().width * 0.65 + 'px')
    }
  }, [])

  return (
    <div
      className='attachment'
      style={{ cursor: externalLink ? 'pointer' : 'default' }}
      onClick={handleClickFile}>
      {!showLoading && showIcon && <File />}
      <p title={fileName} ref={nameRef} style={{ width: nameWidth }}>
        {fileName}
      </p>
      {fileSize && <span>({formatBytes(fileSize, 0)})</span>}
      {removeButton && (
        <div className='attachment__remove' onClick={handleClickRemoveFile}>
          <X />
        </div>
      )}
    </div>
  )
}

export default Attachment
